var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bkr-cc imgmodal",
      attrs: { itemscope: "", itemtype: "http://schema.org/Thing" },
    },
    [
      _c(
        "div",
        {
          ref: "single",
          staticClass:
            "bkr-cc single-carousel owl-carousel owl-theme owl-single-item mt-0",
          attrs: { id: "imageGallery" },
        },
        _vm._l(_vm.singleImages, function (image, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "prop-1-1 slide-owl-wrap bk-ai-hint-host",
            },
            [
              _c(
                "a",
                {
                  class: { largeVideoThumb: image.position < 0 },
                  attrs: {
                    href: _vm.getLightboxUrl(image),
                    "data-fancybox": "single-item-image" + _vm._uid,
                    "data-alt": _vm.getAltText(image),
                    "data-image-classes": _vm.getMetadata(image).classes,
                    "data-video-ratio": _vm.getVideoRatioAttr(image),
                  },
                },
                [
                  _vm.shouldRenderDirectImage(image, index)
                    ? _c("img", {
                        staticClass: "mw-100 h-auto",
                        class: _vm.getMetadata(image).classes,
                        attrs: {
                          src: _vm.getImageInitialSrc(image),
                          alt: _vm.getAltText(image),
                          title: _vm.getImageName(image),
                          width: _vm.getImageWidth(image),
                          height: _vm.getImageHeight(image),
                          fetchpriority: "high",
                          loading: "eager",
                          decoding: "sync",
                        },
                        on: {
                          error: function ($event) {
                            return _vm.handleDirectImageError($event, image)
                          },
                        },
                      })
                    : image.position >= 0 && _vm.shouldLoadMainSlide(index)
                    ? _c("lazy-img", {
                        attrs: {
                          index: index,
                          "image-flags": _vm.getMetadata(image).flags,
                          alt: _vm.getAltText(image),
                          "image-url": _vm.getDisplayUrl(image),
                          title: _vm.getImageName(image),
                          width: _vm.getImageWidth(image),
                          height: _vm.getImageHeight(image),
                        },
                      })
                    : image.position >= 0
                    ? _c("div", { staticClass: "mw-100 h-auto" })
                    : _c("img", {
                        staticClass: "owl-lazy",
                        attrs: {
                          "data-src": image.thumb,
                          alt: "Video abspielen",
                        },
                      }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.shouldRenderDirectImage(image, index) &&
              _vm.currentItem === index &&
              _vm.isCurrentImageAi
                ? _c("ai-image-hint")
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.showThumbs
        ? _c(
            "div",
            {
              ref: "thumbs",
              staticClass: "owl-thumbs owl-carousel owl-theme owl-single-item",
              attrs: { id: "thumb-carousel" },
            },
            _vm._l(_vm.carouselImages, function (imagePreview, idx) {
              return _c("div", { key: idx, staticClass: "prop-1-1" }, [
                _c(
                  "div",
                  {
                    staticClass: "image-container",
                    on: {
                      click: function ($event) {
                        return _vm.goTo(idx)
                      },
                    },
                  },
                  [
                    _vm.shouldLoadThumb(idx)
                      ? _c("lazy-img", {
                          class: {
                            active: _vm.currentItem === idx,
                            videoButton: imagePreview.position < 0,
                          },
                          attrs: {
                            "show-ai-hint": false,
                            "picture-class": imagePreview.class,
                            "image-flags": _vm.getMetadata(imagePreview).flags,
                            "image-url": imagePreview.displayUrl,
                            alt: _vm.getAltText(imagePreview),
                            title: _vm.getImageName(imagePreview),
                            width: _vm.getImageWidth(imagePreview),
                            height: _vm.getImageHeight(imagePreview),
                          },
                        })
                      : _c("div", {
                          class: [
                            imagePreview.class,
                            {
                              active: _vm.currentItem === idx,
                              videoButton: imagePreview.position < 0,
                            },
                          ],
                        }),
                  ],
                  1
                ),
              ])
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }